import './packages-slider.scss'
import anime from 'animejs'
import Vue from 'vue'

export const component = {
    name: 'packages-slider',

    data: {
        index: 0,
        interactions: true,
        timeout: null
    },

    computed: {
        currentPackage () {
            return this.packages[this.index] ? this.packages[this.index] : null
        }
    },

    mounted () {
        this.setTimeout()
    },

    methods: {
        next (e) {
            if (e) {
                e.preventDefault()
            }
            const nextIndex = this.index + 1 === this.packages.length ? 0 : this.index + 1
            this.toggle(nextIndex)
        },

        prev (e) {
            if (e) {
                e.preventDefault()
            }
            const nextIndex = this.index - 1 < 0 ? this.packages.length - 1 : this.index - 1
            this.toggle(nextIndex)
        },

        setTimeout () {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => this.next(), 7500)
        },

        toggle (i) {
            if (!this.interactions) {
                return
            }

            if (i === this.index) {
                return
            }

            clearTimeout(this.timeout)
            this.interactions = false

            Promise.resolve()
                .then(() => {
                    const tween = anime({
                        targets: this.$refs.package,
                        opacity: [1, 0],
                        duration: 200,
                        easing: 'easeInOutQuad'
                    })
                    return tween.finished
                })
                .then(() => new Promise(resolve => {
                    this.index = i
                    Vue.nextTick(() => resolve())
                }))
                .then(() => {
                    const tween = anime({
                        targets: this.$refs.package,
                        opacity: [0, 1],
                        duration: 300,
                        easing: 'easeOutQuint'
                    })
                    return tween.finished
                })
                .then(() => {
                    this.interactions = true
                    this.setTimeout()
                })
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/packages-slider/packages-slider.js